// extracted by mini-css-extract-plugin
export default {"MainLayout":"MainLayout_MainLayout__jCqud","ContentWrapper":"MainLayout_ContentWrapper__-wRCM"};